import styled, { useTheme } from 'styled-components';
import React from 'react';
import Text from './Text';

export default function Heading({
  level = '1',
  weight = 'strong',
  ...props
}) {
  const theme = useTheme();

  const headingLevel = String(level);

  const fontFamily = headingLevel === '1' || headingLevel === '2'
    ? theme.tokens.typography.fontFamily.title
    : theme.tokens.typography.fontFamily.body;

  return (
    <Element
      level={level}
      weight={weight}
      size={theme.tokens.heading.level[headingLevel]}
      fontFamily={fontFamily}
      {...props}
    />
  );
}

const Element = styled(({
  level,
  fontFamily,
  ...props
}) => (
  <Text as={`h${level}`} fontFamily={fontFamily} {...props} />
))`
  margin-top: 0;
  margin-bottom: 0;
`;
